import type { Identifiable } from '@empathyco/playboard-core-domain'
import type { ActionContext } from 'vuex'
import type { ActionClass, ToolingState } from '../../../models'
import type { CrudServiceProvider } from '../../../providers/interfaces'
import { EngagementActionsTypeEnum } from '@empathybroker/tsclient-stats/dist/enums/engagement/engagement-actions-type.enum'
import { CONTAINER } from '../../../config/inversify.config'
import { TYPES } from '../../../config/inversify.types'
import { CRUD_CONSTS } from '../../crud/crud.consts'
import { TOOLING_CONSTS } from '../tooling.consts'

export class CreateAction implements ActionClass {
  static async execute(
    this: void,
    { state, commit, dispatch }: ActionContext<ToolingState, unknown>,
    { tool, item: itemToCreate }: { tool: string; item: Identifiable<string | number> },
  ): Promise<Identifiable<string | number>> {
    const service = CONTAINER.get<CrudServiceProvider>(TYPES.CrudServiceProvider)(tool)
    const createdItem = await service.create(itemToCreate)
    let { results, numFound } = state.tools[tool]?.data ?? { results: [], numFound: 0 }
    results = [...results, createdItem]
    numFound++
    commit(TOOLING_CONSTS.mutations.setState, {
      [tool]: {
        data: {
          results,
          numFound,
        },
      },
    })
    await dispatch(
      `${CRUD_CONSTS.moduleName}/${CRUD_CONSTS.actions.tag}`,
      {
        featureId: tool,
        type: EngagementActionsTypeEnum.CREATE,
      },
      { root: true },
    )
    return createdItem
  }
}
